import { toast } from 'sonner'

const CHECK_INTERVAL_MS = 5 * 60 * 1000

async function fetchShell(): Promise<string | null> {
  try {
    const res = await fetch('/index.html', { cache: 'no-store' })
    return res.ok ? await res.text() : null
  } catch {
    return null
  }
}

// Polls the served index.html; a new deploy changes its hashed asset URLs.
export function startUpdateCheck() {
  let baseline: string | null = null
  let notified = false

  const check = async () => {
    if (notified) return
    const html = await fetchShell()
    if (html === null) return
    if (baseline === null) {
      baseline = html
      return
    }
    if (html !== baseline) {
      notified = true
      clearInterval(timer)
      toast.info('A new version of the app is available.', {
        duration: Infinity,
        action: { label: 'Refresh', onClick: () => window.location.reload() },
      })
    }
  }

  const timer = setInterval(check, CHECK_INTERVAL_MS)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check()
  })
  check()
}
